/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('angular-translate');
require('angular-translate-loader-partial');
require('angular-translate-storage-cookie');
require('angular-translate-storage-local');

module.exports = ['$translateProvider', '$translatePartialLoaderProvider',
  function ($translateProvider, $translatePartialLoaderProvider) {
    $translateProvider
    .useSanitizeValueStrategy(null)
    .storageKey('locale')
    .useLocalStorage()
    .useLoaderCache()
    .addInterpolation('$translateMessageFormatInterpolation')
    .useLoader('$translatePartialLoader',
      { urlTemplate: '{part}/config/locales/{lang}.json' })
    .preferredLanguage('fr_CA')
    .fallbackLanguage('fr_CA');

    return $translatePartialLoaderProvider.addPart('main');
  },

];



// WEBPACK FOOTER //
// ./main/config/initializers/translate.js